// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".V5ltN {\n  border-bottom: var(--border-default-gray-light);\n}\n\n.GWLO6 {\n  position: absolute;\n  right: var(--spacing-md);\n}\n\n.V5ltN,\n.sxM1H {\n  padding: var(--spacing-sm) var(--spacing-md);\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"titleContainer": "V5ltN",
	"closeButton": "GWLO6",
	"contentContainer": "sxM1H"
};
export default ___CSS_LOADER_EXPORT___;
